import React, { useState, useContext, useEffect } from 'react';
// import './dashboard.css';
// import { AuthContext } from '../../../auth'
import { Redirect } from 'react-router-dom';
import Parse from 'parse';
import { Link } from 'react-router-dom'
import Navbar from '../layouts/navbar';
import { AuthContext } from '../../auth';


const Mycouncellors = () => {
    // const [counsellors,setCounsellors] = useState("");
    const [logedinuser, setLogedinuser] = useContext(AuthContext);


    

    return (

        <React.Fragment>
            <Navbar head="Appointments" />

            <div className="container cnt" style={{ fontFamily: "'Open Sans', open-serif" }}>
                <div className="row">
                    <div className="col text-center">
                        <h4 className="mb-0" style={{ color: "#65cdf0" }}>My Appointments</h4>
                        <div class="title-underline" style={{ background: "#65cdf0", marginBottom: "11%" }}></div>
                    </div>
                    <div className="col-12 col-md-6 patientprofiles">

                        {/* {counsellors.map(counsellor => {
                            return (
                                <div className="card">
                                    <div className="card-body">
                                        <div class="media" >
                                            <img class="mr-3" src="/assests/images/user.png" height="30" alt="" />
                                            <div class="media-body">
                                                <h5 class="my-0">{counsellor.get("name")}</h5>
                                                <Link to={`/counsellor/${counsellor.id}`}>
                                                    <i class="fas fa-file-alt fa-2x" style={{ color: "#65cdf0" }}></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })} */}

                        <div className="card">
                            <div className="card-body">
                                <div class="media" >
                                    <img class="mr-3" src="/assests/images/user.png" height="30" alt="" />
                                    <div class="media-body">
                                        <h5 class="my-0">Roar wellness</h5>
                                        {/* <Link to={`/counsellor/${counsellor.id}`}>
                                            <i class="fas fa-file-alt fa-2x" style={{ color: "#65cdf0" }}></i>
                                        </Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default Mycouncellors;